import { render, staticRenderFns } from "./AwaitingMakeup.vue?vue&type=template&id=363e32ae&scoped=true"
import script from "./AwaitingMakeup.vue?vue&type=script&lang=js"
export * from "./AwaitingMakeup.vue?vue&type=script&lang=js"
import style0 from "./AwaitingMakeup.vue?vue&type=style&index=0&id=363e32ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e32ae",
  null
  
)

export default component.exports